export default "__VITE_ASSET__ChedVYpG__"